"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectScript = void 0;
var injectScript = function (src) {
    var d = document;
    var aws = d.createElement('script');
    aws.type = 'text/javascript';
    aws.async = true;
    aws.src = src;
    var s = d.getElementsByTagName('script')[0];
    s && s.parentNode && s.parentNode.insertBefore(aws, s);
};
exports.injectScript = injectScript;
//# sourceMappingURL=index.js.map